<!--
 * @Description: 此组件需要重构，
 * @Date: 2019-08-02 15:05:16
 -->
<template>
  <div class="search">
    <div class="item">
      <dic-select
        @dic-select-obj="saveEnterpriseId4"
        :setEmpty="setEmpty4"
        :fuzzyDef="searchAjax4"
        :ajaxQueryObj="xmfilter"
        :prop="prop4"
        ajaxQuery="dictName"
        placeholder="选择工业方"
      />
    </div>
    <div class="item">
      <dic-select
        @dic-select-obj="saveEnterpriseId1"
        :setEmpty="setEmpty"
        :fuzzyDef="searchAjax"
        :ajaxQueryObj="xmfilter"
        :prop="prop"
        ajaxQuery="name"
        placeholder="选择服务商"
      />
    </div>
    <div class="item">
      <dic-select
        @dic-select-obj="saveEnterpriseId3"
        :setEmpty="setEmpty3"
        :fuzzyDef="searchAjax3"
        :ajaxQueryObj="xmfilter"
        :prop="prop3"
        ajaxQuery="dictName"
        placeholder="选择供应商"
      />
    </div>
    <div class="item">
      <dic-select
        :setEmpty="setEmpty2"
        @dic-select-obj="saveEnterpriseId2"
        :fuzzyDef="searchAjax2"
        :prop="prop2"
        :ajaxQueryObj="xmfilter"
        ajaxQuery="name"
        placeholder="请选择项目名"
      />
    </div>
    <div class="item" v-for="(v, k) in searchItemList" :key="k">
      <div class="title">{{ v.name }}</div>
      <div class="operate">
        <el-input
          v-if="v.slot == 'input'"
          :placeholder="v.tip"
          v-model.trim="v.val"
          :style="{ width: `${v.width ? v.width : width}px` }"
        />
        <el-date-picker
          v-if="v.slot == 'date'"
          v-model="v.val"
          type="month"
          :placeholder="defaultTime()"
          @change="handleTime(...arguments, k)"
          :style="{ width: `${v.width ? v.width : width}px` }"
        />
        <el-select
          v-if="v.slot == 'select'"
          v-model="v.val"
          :mode="v.multiple ? 'multiple' : ''"
          :placeholder="v.tip"
          @change="choose(...arguments, k)"
          :style="{
            minWidth: `${v.width ? v.width : width}px`,
            width: v.multiple ? 'initial' : `${v.width ? v.width : width}px`
          }"
        >
          <el-option
            :value="optv.key"
            :label="optv.name"
            v-for="(optv, optk) in v.options"
            :key="optk"
          />
        </el-select>
        <el-date-picker
          v-if="v.slot == 'daterange'"
          v-model="v.val"
          type="daterange"
          :default-value="rangeDefaultDate"
          popper-class="next-month-range"
          @change="changRangeValue(...arguments, k)"
          :style="{
            minWidth: `${v.width ? v.width : width}px`,
            width: v.multiple ? 'initial' : `${v.width ? v.width : width}px`
          }"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </div>
    </div>
    <el-button size="small" class="btn" type="primary" @click="sure('search')">
      搜索
    </el-button>
    <el-button
      v-if="isexport"
      class="btn"
      size="small"
      type="warning"
      @click="sure('taskExport')"
    >
      导出
    </el-button>
    <el-button
      v-if="isexportT"
      class="btn"
      size="small"
      type="warning"
      @click="sure('taskExport2')"
    >
      {{ exportBtnText || '导出调研详情' }}
    </el-button>
    <el-button
      v-if="isexportSan"
      class="btn"
      size="small"
      type="warning"
      @click="sure('taskExport3')"
    >
      {{ exportSanBtnText || '导出' }}
    </el-button>
    <el-dialog
      :visible="exportNowStep >= 0"
      v-if="exportNowStep >= 0"
      :show-close="false"
      class="export-dialog"
      width="30%"
      append-to-body
    >
      <div
        class="export-dialog-item"
        v-for="(item, index) in exportStep"
        :key="index"
        :style="{ height: exportNowStep >= index ? '50px' : '0' }"
      >
        <i class="el-icon-check" v-if="exportNowStep > index"></i>
        <el-button
          type="text"
          :class="{ ok: exportNowStep > index }"
          :loading="index == exportNowStep"
        >
          {{ item }}
        </el-button>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
        v-if="exportNowStep >= exportStep.length"
      >
        <el-button
          type="primary"
          @click="exportNowStep = -1"
          v-if="exportNowStep == exportStep.length"
        >
          确 定
        </el-button>
        <el-button
          type="primary"
          @click="exportNowStep = -1"
          v-if="exportNowStep == exportStep.length + 1"
        >
          关闭
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import dicSelect from '@/components/Common/dicSelect.vue';
import { order, company, aAlly } from '@/api/ajax';

export default {
  props: {
    // 任务记录0 任务汇总1
    childActiveIndex: {
      type: Number,
      default: 0
    },
    // 项目类型
    projectType: {
      type: Number,
      default: 0
    },
    // 渲染内容 包含了label、字段、类型
    searchItem: {
      type: Array,
      default: () => {
        return [];
      }
    },
    searchAjax: { type: Function, default: company.listB }, // 企业搜索select传入接口
    searchAjax2: { type: Function, default: company.projectList }, // 项目搜索select传入接口
    searchAjax3: { type: Function, default: company.listP }, // 供应商
    searchAjax4: { type: Function, default: company.listI }, // 供应商
    isexport: { type: Boolean, default: false }, // 是否显示导出 sure 0 parent.ajaxExport
    isexportT: { type: Boolean, default: false }, // 是否显示导出 sure 2 导出调研详情 parent.ajaxExport2
    isexportSan: { type: Boolean, default: false }, // 是否显示导出 sure 3 导出调研详情 parent.ajaxExport3
    exportBtnText: { type: String, default: '导出调研详情' }, // sure 2 显示文字
    exportSanBtnText: { type: String, default: '导出' }, // sure 3 显示文字
    searchCtrl: { type: Object, default: {} }, // 混入数据 projectSearchList { type: 1, projectType: 1, oneType: 1, twoType: 1 }
    taskExportData: {
      type: Function | Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      exportNowStep: -1,
      width: 140,
      //   height: 32,
      show: false,
      prop: {
        label: 'enterprise_name',
        code: 'id'
      },
      prop2: {
        label: 'project_name',
        code: 'id'
      },
      prop3: {
        label: 'supplierName',
        code: 'supplierId'
      },
      prop4: {
        label: 'industryName',
        code: 'industryEnterpriseId'
      },
      searchQuery: {
        enterpriseId: '',
        projectId: '',
        supplierId: '',
        industryEnterpriseId: ''
      },
      rangeDefaultDate: new Date().toDateString(),
      setEmpty: 0,
      setEmpty2: 0,
      setEmpty3: 0,
      setEmpty4: 0,
      exportStep: [
        '查询问卷题目数据',
        '查询问卷答题数据',
        '报表数据准备中',
        '报表生成中',
        '报表生成完成'
      ]
    };
  },
  components: {
    dicSelect
  },
  watch: {
    // 切换后置空
    searchCtrl() {
      this.clear();
    },
    // 切换后置空
    searchAjax() {
      this.emptySelect('');
    },
    // 切换后置空
    searchAjax2() {
      this.emptySelect(2);
    },
    // 切换后置空
    searchAjax3() {
      this.emptySelect(3);
    },
    // 切换后置空
    searchAjax4() {
      this.emptySelect(4);
    }
  },
  computed: {
    // todo 这里配置项目的查询
    xmfilter() {
      let enterpriseId = this.searchQuery.enterpriseId || '';
      let industryEnterpriseId = this.searchQuery.industryEnterpriseId || '';
      let supplierEnterpriseId = this.searchQuery.supplierId || '';
      let queryCsoProject = this.$route.meta.queryCsoProject;
      return Object.assign(
        {
          enterpriseId,
          industryEnterpriseId,
          supplierEnterpriseId,
          queryCsoProject
        },
        this.searchCtrl
      );
    },
    searchItemList() {
      let use = +this.$parent.tableResp.name || 0;
      return (this.searchItem || []).filter(res => {
        let forUse = res.use;
        if (!forUse) {
          return true;
        }
        if (Array.isArray(forUse)) {
          return forUse.includes(use);
        }
      });
    }
  },
  methods: {
    emptySelect(type) {
      this.searchQuery = {
        enterpriseId: '',
        projectId: '',
        supplierId: '',
        industryEnterpriseId: ''
      };
      this[`setEmpty${type}`] = +new Date();
    },
    createFrame(url, time = 0) {
      var element = document.createElement('frame');
      element.src = url;
      element.style.display = 'none';
      document.body.appendChild(element);
      setTimeout(() => {
        document.body.removeChild(element);
      }, time);
    },
    // taskRecordDiaoyanPageListExportV2New 导出调用该方法，医学调研
    dataExport(url) {
      if (this.taskExportData) {
        const a = window.localStorage.getItem('Authorization');
        this.createFrame(`${url}&authorization=${a}`, 1000);
        this.exportNowStep = 0;
        setTimeout(() => {
          this.exportResult(a);
        }, 1000);
      }
    },
    exportResult(a) {
      this.taskExportData({
        authorization: a
      })
        .then(res => {
          const info = res.data.data || {};
          if (!('report_generation_state' in info)) {
            this.$message.error('导出失败');
            this.exportNowStep = -1;
            return;
          }
          if (info.report_generation_state == 0) {
            this.exportNowStep = info.step;
            setTimeout(() => {
              this.exportResult(a);
            }, 2000);
          }
          if (info.report_generation_state == 1) {
            this.exportNowStep = this.exportStep.length;
            this.$message({
              message: '导出成功，正在下载中...',
              type: 'success'
            });
            this.createFrame(info.report_link, 10000);
          }
          if (info.report_generation_state == -1) {
            // this.exportNowStep = this.exportStep.length+1
            this.$message.error('导出失败');
            this.exportNowStep = -1;
          }
          if (info.report_generation_state == -2) {
            // this.exportNowStep = this.exportStep.length+1
            this.$message.error('暂无数据');
            this.exportNowStep = -1;
          }
        })
        .catch(err => {
          this.$message.error('导出失败');
          this.exportNowStep = -1;
        });
    },
    /**
     * @description: 导出
     * @param {string,object}  exportUrl导出接口 obj混入参数
     * @return:
     */
    baseExport(exportUrl, obj) {
      if (this.$parent.tableData.length === 0) {
        return;
      }
      let query = Object.assign(
        {},
        this.$parent.searchQuery,
        this.$parent.paginationData,
        obj
      );
      let target = {};
      for (let i of Object.keys(query)) {
        if (query[i] !== '' && query[i] != null) {
          target[i] = query[i];
        }
      }
      if (this.$parent.searchQuery.enterpriseId) {
        let queryString = this.$querystring.stringify(target);
        let url = exportUrl;
        const hasQuery = url.indexOf('?') > -1;
        if (!hasQuery) {
          url = url + '?';
        }
        if (
          url.includes(
            '/taskRecordAndSummaryDoc/taskRecordDiaoyanPageListExportV2New'
          )
        ) {
          //医学调研->任务记录->导出调研详情
          this.dataExport(url + queryString);
        } else {
          window.open(url + queryString);
        }
      } else {
        this.$message.error('请选择企业');
      }
    },
    changRangeValue(date, index) {
      this.searchItem[index].val = date;
    },
    saveEnterpriseId1(val) {
      this.searchQuery.enterpriseId = val.id;
      this.setEmpty2 = +new Date();
      this.searchQuery.projectId = '';
    },
    saveEnterpriseId2(val) {
      this.searchQuery.projectId = val.id;
    },
    saveEnterpriseId3(val) {
      this.searchQuery.supplierEnterpriseId = val.supplierId;
      this.setEmpty2 = +new Date();
      this.searchQuery.projectId = '';
    },
    saveEnterpriseId4(val) {
      this.searchQuery.industryEnterpriseId = val.industryEnterpriseId;
      this.setEmpty2 = +new Date();
      this.searchQuery.projectId = '';
    },
    dealDate(date) {
      if (date.length != 2) {
        return false;
      }
      // console.log(date[0], date[0].format("L"));
      const starttime = new Date(`${date[0].format('L')}`).getTime();
      const endtime = new Date(`${date[1].format('L')}`).getTime();
      return {
        starttime: starttime,
        endtime: parseInt(endtime) + 60 * 60 * 24 * 1000 - 1000
      };
    },
    /**
     * @description: 格式化时间
     * @param {date,'month'|'d'} value时间 type格式化类型 到月|到日
     * @return: dateString
     */
    defaultTime(value, type = 'month') {
      let date = new Date();
      if (value) {
        date = value;
      }
      let month = date.getMonth() + 1;
      let yearMonth = `${date.getFullYear()}-${
        month < 10 ? '0' + month : month
      }`;
      if (type == 'd') {
        const day = date.getDate();
        return `${yearMonth}-${day < 10 ? '0' + day : day}`;
      }
      return yearMonth;
    },
    handleTime(date, index) {
      this.searchItem[index].val = this.defaultTime(date);
      //todo 清空日期选择器
      let target = this.searchItem.find(res => {
        return res.tip === '时间区间';
      });
      this.$nextTick(() => {
        try {
          if (target) {
            delete target['val'];
            this.rangeDefaultDate = date ? date.toString() : this.defaultTime();
          }
        } catch (e) {
          console.log(e, 2222);
        }
      });
    },
    onChange(date, index) {
      this.searchItem[index].val = date;
    },
    input(val, index) {
      this.searchItem[index].val = val;
    },
    choose(val, index) {
      this.searchItem[index].val = val;
    },
    clear(notClearProject) {
      const data = [...this.searchItem];
      let flag = false;
      data.forEach((v, k) => {
        if (v.val || v.val == 0) {
          delete this.searchItem[k]['val'];
          this.$set(this.searchItem, k, this.searchItem[k]);
          flag = true;
        }
      });
      if (!notClearProject) {
        this.searchQuery = {
          enterpriseId: '',
          projectId: '',
          supplierId: '',
          industryEnterpriseId: ''
        };
      }
      this.setEmpty = this.setEmpty2 = this.setEmpty3 = this.setEmpty4 = +new Date();

      flag && this.$emit('clear');
    },
    /**
     * @description: 搜索，3种导出
     * @param {Number} 0:parent.ajaxExport 1:搜索 2:parent.ajaxExport2 3:parent.ajaxExport3
     */
    sure(forUse) {
      const data = [...this.searchItem];
      let obj = {};
      let flag = false;
      data.forEach(v => {
        if (v.val || v.val == 0) {
          if (Array.isArray(v.key)) {
            v.key.forEach((k, i) => {
              // 格式化数组内时间格式
              obj[k] = this.defaultTime(v.val[i], 'd');
            });
          } else {
            obj[v.key] = v.val;
          }
        }
      });
      obj = Object.assign(obj, this.searchQuery);
      // 兼容相同含义不同字段
      // 合并企业查询
      ['enterpriseId', 'csoId', 'enterprise_id'].forEach(res => {
        obj[res] = obj.enterpriseId;
      });
      // 合并日期
      ['taskDt', 'task_dt', 'month'].forEach(res => {
        obj[res] = obj.taskDt || this.defaultTime();
      });
      // 合并企业id
      ['project_id'].forEach(res => {
        obj[res] = obj.projectId;
      });

      ['auditStatus', 'authStatus'].forEach(res => {
        obj[res] = obj.authStatus;
      });

      // 必须又企业与项目信息
      if (this.searchQuery.enterpriseId && this.searchQuery.projectId) {
        flag = true;
      }
      if (!flag) {
        this.$message.error('需要选择企业名称和项目名字');
      } else {
        if (forUse == 'search') {
          this.$emit('search', obj);
        } else {
          let ajaxPart =
            aAlly[this.$parent.target.marked][
              'part' + this.$parent.childActiveIndex
            ];
          this.baseExport(ajaxPart[forUse](), obj);
        }
      }
    }
  }
};
</script>
<style scoped lang="scss">
.search {
  display: flex;
  flex-wrap: wrap;

  .item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .title {
      margin-right: 5px;
    }

    .operate {
      margin-right: 10px;
    }
  }

  .btn {
    height: 40px;
    margin-left: 30px;
  }
}
.export-dialog-item {
  display: flex;
  align-items: center;
  font-size: 20px;
  transition: all 0.3s;
  overflow: hidden;
  .el-icon-check {
    margin-right: 4px;
    color: #1989fa;
  }
  .el-button--text {
    font-size: 18px;
    color: #6d6d6d;
    &.ok {
      color: #1989fa;
    }
  }
}
</style>
